import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { 
  CustomsClearanceRequest, 
  CustomsClearanceEvent, 
  PaginatedResponse, 
  ApiResponse,
  CustomsFilters
} from '../../models/document.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomsClearanceService {
  private readonly baseUrl = `${environment.apiUrl}/api/customs`;

  constructor(private http: HttpClient) {}

  // Process customs clearance request
  processCustomsClearance(request: CustomsClearanceRequest): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.baseUrl}/clearance`, request);
  }

  // Get customs clearance status for a specific carrier tracking number
  getCustomsClearanceStatus(carrierTrackingNumber: string): Observable<ApiResponse<CustomsClearanceEvent[]>> {
    return this.http.get<ApiResponse<CustomsClearanceEvent[]>>(`${this.baseUrl}/clearance/${carrierTrackingNumber}`);
  }

  // Get pending customs clearances with pagination
  getPendingCustomsClearances(filters: CustomsFilters): Observable<PaginatedResponse<CustomsClearanceEvent>> {
    let params = new HttpParams()
      .set('pageSize', filters.pageSize.toString())
      .set('pageNumber', filters.pageNumber.toString());

    if (filters.searchTerm) {
      params = params.set('searchTerm', filters.searchTerm);
    }
    if (filters.region) {
      params = params.set('region', filters.region);
    }
    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.dateFrom) {
      params = params.set('dateFrom', filters.dateFrom);
    }
    if (filters.dateTo) {
      params = params.set('dateTo', filters.dateTo);
    }

    return this.http.get<PaginatedResponse<CustomsClearanceEvent>>(`${this.baseUrl}/pending`, { params });
  }

  // Get customs clearance progress for a specific reference number
  // This is different from clearance status - this retrieves progress updates from CustomsClearanceProgresses table
  getCustomsClearanceProgress(referenceNo: string): Observable<ApiResponse<any[]>> {
    return this.http.get<ApiResponse<any[]>>(`${this.baseUrl}/progress/${referenceNo}`);
  }
}
